import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class ForgotPasswordFromLoginGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(): boolean {
        const navState = this.router.getCurrentNavigation()?.extras?.state;
        const fromLoginByNav = navState?.['fromLogin'] === true;

        // 念のため history.state も確認（同一タブ内の遷移向け）
        const fromLoginByHistory =
            typeof window !== 'undefined' &&
            window.history?.state?.fromLogin === true;

        if (fromLoginByNav || fromLoginByHistory) {
            return true;
        }

        this.router.navigate(['/login']);
        return false;
    }
}